export const aiSteps = {
  MODULE: 'MODULE',
  SUB_CATEGORY: 'SUB_CATEGORY',
  CATEGORY_TYPE: 'CATEGORY_TYPE',
  CHOOSE_IMMEDIATE_PICKUP: 'CHOOSE_IMMEDIATE_PICKUP',
  CHOOSE_IMMEDIATE_DROPOFF: 'CHOOSE_IMMEDIATE_DROPOFF',
  CONFIRM_LOCATIONS: 'CONFIRM_LOCATIONS',
  CHOOSE_CAB: 'CHOOSE_CAB',
  SUCCESS: 'SUCCESS',
  CHOOSE_VEHICLE: 'CHOOSE_VEHICLE',
  CHOOSE_BRAND: 'CHOOSE_BRAND',
  CHOOSE_MODEL: 'CHOOSE_MODEL',
  CHOOSE_MANUFACTURE_YEAR: 'CHOOSE_MANUFACTURE_YEAR',
  CHOOSE_NO_OF_VEHICLES: 'CHOOSE_NO_OF_VEHICLES',
  CHOOSE_TRIPS: 'CHOOSE_TRIPS',
  CHOOSE_RENTAL_EXTRA: 'CHOOSE_RENTAL_EXTRA',
  CHOOSE_COMMODITY: 'CHOOSE_COMMODITY',
  CHOOSE_DELIVERY_TIME: 'CHOOSE_DELIVERY_TIME',
  CHOOSE_SCHEDULE_PICKUP: 'CHOOSE_SCHEDULE_PICKUP',
  CHOOSE_SCHEDULE_DROPOFF: 'CHOOSE_SCHEDULE_DROPOFF',
  CHOOSE_DROPOFF_RECEIVER: 'CHOOSE_DROPOFF_RECEIVER',
  CHOOSE_SCHEDULE_TIME: 'CHOOSE_SCHEDULE_TIME',
  CHOOSE_BID_START_TIME: 'CHOOSE_BID_START_TIME',
  CHOOSE_BID_END_TIME: 'CHOOSE_BID_END_TIME',
};

export const aiLocation = [
  'CHOOSE_IMMEDIATE_PICKUP',
  'CHOOSE_IMMEDIATE_DROPOFF',
  'CHOOSE_SCHEDULE_PICKUP',
  'CHOOSE_SCHEDULE_DROPOFF',
];

export const aiNavigation = {
  HOME: 'HOME',
  IMMEDIATE_SCHEDULE: 'IMMEDIATE_SCHEDULE',
  IMMEDIATE_LOCATION: 'IMMEDIATE_LOCATION',
  AVAILABLE_CABS: 'AVAILABLE_CABS',
  AVAILABLE_VEHICLES: 'AVAILABLE_VEHICLES',
  SCHEDULE_ENQUIRY: 'SCHEDULE_ENQUIRY',
  ENQUIRY_SUCCESS: 'ENQUIRY_SUCCESS',
};

export const AI_CHAT_IDLE_TIMEOUT_MS = 30000;
export const AI_CHAT_CLOSE_TIMEOUT_MS = 60000;
